var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',[_c('h3',[_vm._v("Tentang Inspektorat")])]),_c('div',{staticClass:"mb-5"},[_c('CSambutan')],1),_c('div',[_c('CTentang')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }